import React from 'react';

import { Wrapper, Content } from './Grid.styles'
import Knoppie from '../Knoppie'
import Display from '../Display'

const Grid = ({ header,children,id,destination,home }) => (

    
        <>
       
        <Wrapper> 
         <h3>{header}</h3>
       
        <Content>
            {children}
        </Content>
    </Wrapper>
    </>

);

export default Grid;